import { FC } from 'react';

import { Title } from '../../UI/title/Title';
import Breadcrumbs from '../../breadcrumbs/Breadcrumbs';

import styles from './BlogPageHead.module.scss';

interface BlogPageHeadProps {
    title: string;
    description: string;
}

const BlogPageHead: FC<BlogPageHeadProps> = ({ title, description }) => {
    return (
        <div className={styles.blogHead}>
            <Breadcrumbs />
            <div className={styles.blogHeadMain}>
                <Title text={title} size="xl" className={styles.blogHeadMain__title} />

                <p className={`excerpt body-lg excerpt-wrap ${styles.blogHeadMain__desc}`}>
                    {description}
                </p>
            </div>
        </div>
    );
};

export { BlogPageHead };
